<template>
  <div class="row">
    <b-form-group :label="$t('reportEditable.form.fields.exam.label')" class="col-md-5">
      <SelectTuevsExam class="mb-3" v-model="form.tuevs_exam" :model="form.tuevs_exam" :filters="filteSelectTuevsExam" />
    </b-form-group>
    <b-form-group :label="$t('reportEditable.form.fields.mnemonic.label')" class="col-md-5">
      <b-form-input v-model="form.mnemonic" />
    </b-form-group>
    <b-form-group :label="$t('reportEditable.form.fields.action.label')" class="col-md-2">
      <button class="btn btn-sm btn-outline-danger"
        @click="removeExam(form.index)"
        type="button"
      >
        <i class="fa fa-minus-circle"></i>
      </button>
    </b-form-group>
  </div>
</template>

<script>
import SelectTuevsExam from "@/components/tuevs/Select/SelectTuevsExam";

export default {
  name: "ExamEditable",
  components: {
    SelectTuevsExam
  },
  props: {
    form: {
      index: {
        Number,
        default: 0
      },
      tuevs_exam: {
        Object,
        default: () => ({})
      },
      mnemonic: {
        String,
        default: null
      }
    }
  },
  data() {
    return {
      filteSelectTuevsExam: [['order_observation', 'IN', ['order', 'both']]]
    }
  },
  methods: {
    removeExam(index) {
      this.$emit('removeExam', index);
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
